import { defineProperty as _defineProperty, inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Theme, Link, IconCloseThick } from '@piggybank/core';
import { CSSTransition } from 'react-transition-group';
import AnimateHeight from 'react-animate-height';
import styles from './add-another.css.js';

var AddAnotherItem = /*#__PURE__*/function (_Component) {
  _inherits(AddAnotherItem, _Component);

  function AddAnotherItem(props) {
    var _this;

    _classCallCheck(this, AddAnotherItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddAnotherItem).call(this, props));
    _this.ref = React.createRef();
    return _this;
  }

  _createClass(AddAnotherItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.focus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.focus) {
        this.focus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.focusTimeout);
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this2 = this;

      if (this.props.focus) {
        this.focusTimeout = setTimeout(function () {
          var firstInput = _this2.ref.current.querySelector('input, select');

          if (firstInput && _this2.props.focusFirstInput) {
            firstInput.focus();
          } else {
            _this2.ref.current.focus();
          }
        }, this.props.duration + 50);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          state = _this$props.state,
          showRemove = _this$props.showRemove,
          onRemove = _this$props.onRemove,
          removeButtonText = _this$props.removeButtonText,
          duration = _this$props.duration,
          easing = _this$props.easing,
          children = _this$props.children,
          focusFirstInput = _this$props.focusFirstInput;
      var strongLink = Theme.select({
        redbrand: false,
        mands: true
      });
      var itemTabIndex = focusFirstInput ? null : '-1';
      return React.createElement(AnimateHeight, {
        height: state === 'entered' ? 'auto' : 0,
        duration: duration,
        easing: easing
      }, React.createElement("div", {
        className: styles.item,
        ref: this.ref,
        tabIndex: itemTabIndex
      }, React.createElement("div", {
        className: styles.itemWrapper
      }, React.createElement("div", {
        className: styles.removeContainerSpacer
      }, removeButtonText), React.createElement("div", {
        className: styles.itemInner
      }, children), React.createElement(CSSTransition, {
        in: showRemove,
        timeout: 150,
        classNames: styles.removeContainer
      }, React.createElement("div", {
        className: cn(styles.removeContainer, _defineProperty({}, styles['removeContainer--hidden'], !showRemove))
      }, React.createElement(Link, {
        iconSlotRight: React.createElement(IconCloseThick, {
          inline: true
        }),
        strong: strongLink,
        elementType: "button",
        type: "button",
        onClick: onRemove,
        hoverUnderline: true,
        buttonPadding: true
      }, removeButtonText))))));
    }
  }]);

  return AddAnotherItem;
}(Component);

_defineProperty(AddAnotherItem, "defaultProps", {
  showRemove: true,
  duration: 200
});

AddAnotherItem.propTypes = process.env.NODE_ENV !== "production" ? {
  state: PropTypes.string.isRequired,
  showRemove: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  removeButtonText: PropTypes.node.isRequired,
  duration: PropTypes.number,
  easing: PropTypes.string,
  children: PropTypes.node,
  focus: PropTypes.bool,
  focusFirstInput: PropTypes.bool
} : {};
AddAnotherItem.displayName = 'AddAnotherItem';
export default AddAnotherItem;